<template>
  <div class="wrapper">
    <Topbar />
    <HorizontalNav />

    <div class="content-page">
      <div class="content">
        <b-container fluid>
          <slot></slot>
        </b-container>
      </div>
    </div>

    <RightSidebar />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted, watch } from 'vue'
import Topbar from '@/views/components/layouts/partials/topbar.vue'
import RightSidebar from '@/views/components/layouts/partials/right-sidebar.vue'
import HorizontalNav from '@/views/components/layouts/partials/horizontal-nav.vue'

export default defineComponent({
  components: { HorizontalNav, Topbar, RightSidebar },
  setup() {
    const html = document.getElementsByTagName('html')[0]
    const showMenu = ref(window.screen.width > 768)
    const layoutWidth = ref('fluid')

    const toggleMenu = () => {
      showMenu.value = !showMenu.value
    }

    const toggleRightSidebar = () => {
      document.body.classList.toggle('right-bar-enabled')
    }

    const hideRightSidebar = () => {
      document.body.classList.remove('right-bar-enabled')
    }

    const activateWidth = (width: string) => {
      if (width === 'boxed') {
        document.body.setAttribute('data-layout-mode', 'boxed')
      } else {
        document.body.removeAttribute('data-layout-mode')
      }
    }

    onMounted(() => {
      html?.setAttribute('data-layout', 'topnav')
      document.body.classList.remove('authentication-bg', 'authentication-bg-pattern')
      activateWidth(layoutWidth.value)
    })

    onUnmounted(() => {
      html?.removeAttribute('data-layout')
    })

    watch(layoutWidth, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        activateWidth(newVal)
      }
    })

    return {
      showMenu,
      layoutWidth,
      toggleMenu,
      toggleRightSidebar,
      hideRightSidebar,
    }
  },
})
</script>
